<template>
  <div class="h100 pt10 pr20 pb20 pl20 bg-w card-01" v-loading="loading">
    <p class="w100 bold font-18 tx-c">{{ userData.deptName }}</p>

    <div class="w100 mt20 flex-box al-c sift-view">
      <DateComp class="mr20" ref="date" :loading="loading" @change="initPage" />
      <el-button type="primary" size="mini" @click="initPage">查询</el-button>
      <el-button type="warning" size="mini" @click="showSearchView">服务查询</el-button>
    </div>

    <div class="w100 mt20">
      <div class="w100 po-r flex-box serve-count-survey">
        <div class="ml10 mr10 white tx-c flex-1 survey-card" style="background: #64c871;">
          <p class="font-24">{{ headCount.serveQuantity }}</p>
          <p class="font-14">服务流程数量</p>
        </div>
        <div class="ml10 mr10 white tx-c flex-1 survey-card" style="background: #999845;">
          <p class="font-24">{{ headCount.servicePersonNum }}</p>
          <p class="font-14">服务人数</p>
        </div>
        <div class="ml10 mr10 white tx-c flex-1 survey-card" style="background: #8e3fc5;">
          <p class="font-24">{{ headCount.serveNum }}</p>
          <p class="font-14">服务次数</p>
        </div>
        <div class="ml10 mr10 white tx-c flex-1 survey-card" style="background: #797979;">
          <p class="font-24">{{ headCount.endNum }}/{{ headCount.endRate }}%</p>
          <p class="font-14">办结数/办结率</p>
        </div>
        <div class="ml10 mr10 white tx-c flex-1 survey-card" style="background: #286595;">
          <p class="font-24">{{ headCount.avgTakeTime | costTimeH }}</p>
          <p class="font-14">流程平均耗时</p>
        </div>
        <div class="ml10 mr10 white tx-c flex-1 survey-card" style="background: #8d2094;">
          <p class="font-24">{{ headCount.avgAppraiseScore ? headCount.avgAppraiseScore : '-' }}分</p>
          <p class="font-14">评价平均值</p>
        </div>
      </div>
    </div>

    <div class="w100 mt20 po-r serve-count-table">
      <el-table class="w100 tx-c my-table" :data="list" stripe border>
        <el-table-column align="center" label="序号" prop="orderNo" width="60px"></el-table-column>
        <el-table-column align="center" label="服务名称" prop="serveName" width="200px"></el-table-column>
        <el-table-column align="center" label="主办部门" prop="hostDept" width="200px"></el-table-column>
        <el-table-column align="center" label="服务主题" prop="serveTitle" width="160px"></el-table-column>
        <el-table-column align="center" label="办理数" prop="handleNum" width="80px"></el-table-column>
        <el-table-column align="center" label="流程发起数" prop="initiateNum" width="100px"></el-table-column>
        <el-table-column align="center" label="流程办结数" prop="endNum" width="100px"></el-table-column>
        <el-table-column align="center" label="办结率" prop="endRate" width="80px"></el-table-column>
        <el-table-column align="center" label="访问次数" prop="visitNum" width="80px"></el-table-column>
        <el-table-column align="center" label="收藏数" prop="collectionNum" width="80px"></el-table-column>
        <el-table-column align="center" label="服务人数" prop="servicePersonNum" width="80px"></el-table-column>
        <el-table-column align="center" label="评价数" prop="appraiseNum" width="80px"></el-table-column>
        <el-table-column align="center" label="评价" prop="avgAppraiseScore" width="80px"></el-table-column>
        <el-table-column align="center" label="时长" width="150px">
          <template slot-scope="scope">
            {{ scope.row.avgTakeTime | costTime }}
          </template>
        </el-table-column>
      </el-table>
      <div class="w100 mt20 tx-r">
        <el-pagination @size-change="changeSize" @current-change="changePage" :current-page="pageNum" :page-sizes="[10, 20, 30, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" background :total="total"></el-pagination>
      </div>
    </div>

    <ServeDialog ref="serveDialog" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DateComp from "@/components/public/DateComp";
import ServeDialog from "@/components/statistical/ServeDialog";

export default {
  name: "CollegeView01",
  components: {
    DateComp,
    ServeDialog
  },
  props: [],
  data() {
    return {
      loading: false,

      startDate: "",
      endDate: "",
      deptId: "",
      pageNum: 1,
      pageSize: 20,
      total: 0,

      headCount: {
        serveQuantity: 0,
        servicePersonNum: 0,
        serveNum: 0,
        endNum: 0,
        endRate: "",
        avgTakeTime: "",
        avgAppraiseScore: ""
      },
      list: []
    };
  },
  computed: {
    ...mapGetters(["userData"])
  },
  created() {},
  mounted() {
    this.initPage();
  },
  destroyed() {},
  methods: {
    fetchList() {
      this.loading = true;

      const date = this.$refs.date.getValue();
      this.$http
        .post(
          `serveCount/byCollege`,
          JSON.stringify({
            startDate: date[0],
            endDate: date[1],
            pageNum: this.pageNum,
            pageSize: this.pageSize
          }),
          {
            headers: {
              "Content-Type": "application/json;charset=utf-8"
            }
          }
        )
        .then(({ data }) => {
          if (data.resCode == "0") {
            this.headCount.serveQuantity =
              data.resData.serveCountSurvey.serveQuantity;
            this.headCount.servicePersonNum =
              data.resData.serveCountSurvey.servicePersonNum;
            this.headCount.serveNum = data.resData.serveCountSurvey.serveNum;
            this.headCount.endNum = data.resData.serveCountSurvey.endNum;
            this.headCount.endRate = data.resData.serveCountSurvey.endRate;
            this.headCount.avgTakeTime =
              data.resData.serveCountSurvey.avgTakeTime;
            this.headCount.avgAppraiseScore =
              data.resData.serveCountSurvey.avgAppraiseScore;

            this.list = data.resData.countPage.list;
            this.total = data.resData.countPage.total;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    initPage() {
      this.pageNum = 1;
      this.list = [];
      this.fetchList();
    },
    changeSize(value) {
      this.pageSize = value;
      this.fetchList();
    },
    changePage(value) {
      this.pageNum = value;
      this.fetchList();
    },
    showSearchView() {
      this.$refs.serveDialog.showView();
    }
  },
  watch: {},
  filters: {
    costTimeH(value) {
      if (!value) return "-";
      const time = Math.floor(value / 1000);
      const day = Math.floor(time / (3600 * 24));
      const hour = Math.floor((time - day * 3600 * 24) / 3600);
      const min = Math.floor((time - day * 3600 * 24 - hour * 3600) / 60);
      let str = "";
      if (day > 0) {
        str += day + "天";
      }
      if (hour > 0) {
        str += hour + "时";
      }
      if (str == "") {
        str += min + "分";
      }
      return str;
    }
  }
};
</script>

<style scoped>
.card-01 {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}

.survey-card {
  padding: 20px 10px;
  border-radius: 4px;
}
</style>
